import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionOptionI18nDescription } from "./description";
import { QuestionOptionI18nName } from "./name";

import type { StandardOptionI18nCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	base: StandardOptionI18nCategoriesAndManagerStore["base"];
};

export const QuestionOptionI18nBase = ({ base }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={base}>
			<QuestionOptionI18nName />
			<QuestionOptionI18nDescription />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionOptionI18nBase.displayName = "QuestionOptionI18nBase";
